export class GridMetadata {
  private static _main: any[] = [
    { title: 'Member Firm Code', columnName: 'name', type: 'text', width: '60px' },
    { title: 'Country Code - Description', columnName: 'name', type: 'text', width: '100px' },
    { title: 'First Name', columnName: 'name', type: 'text', width: '70px' },
    { title: 'Last Name', columnName: 'name', type: 'text', width: '70px' },
    { title: 'Employee Alias', columnName: 'name', type: 'text', width: '100px' },
    { title: 'Email', columnName: 'email', type: 'text', width: '100px' },
    { title: 'Office Code - Description', columnName: 'name', type: 'text', width: '100px' },
    { title: 'Job Title', columnName: 'name', type: 'text', width: '100px' },
    { title: 'Employee Type', columnName: 'name', type: 'text', width: '70px' },
    { title: 'Employee Status Code - Description', columnName: 'name', type: 'text', width: '90px' },
    { title: 'Phone', columnName: 'name', type: 'text', width: '100px' },
    { title: 'Organization Code - Description', columnName: 'name', type: 'text', width: '100px' },
    { title: 'PPMD', columnName: 'name', type: 'text', width: '50px' },
    { title: 'Region', columnName: 'name', type: 'text', width: '80px' },
    { title: 'Personnel Area Code - Description', columnName: 'name', type: 'text', width: '100px' }
  ];

  public static main = function (): Array<any> {
    let main = this._main.slice();
    main.unshift(
      { title: 'GUID From PDI (EMPGUID)', columnName: 'name', type: 'text', width: '65px' },
      { title: 'Global Person ID (DC2GUID)', columnName: 'name', type: 'text', width: '65px' },
      { title: 'Person Id (EmpCode)', columnName: 'name', type: 'text', width: '65px' },
      { title: 'Previous Person Id', columnName: 'name', type: 'text', width: '65px' }, );
    main.push({ title: '', columnName: 'name', type: 'actions', width: '20px' });

    return main;
  };
  public static containermapping = function (): Array<any> {
    let containermapping = [
      { title: 'Container id', columnName: 'name', type: 'text', width: '100px' },
      { title: 'Container Name', columnName: 'name', type: 'text', width: '150px' },
      { title: 'Container Code', columnName: 'name', type: 'text', width: '150px' },
      { title: 'Application Code', columnName: 'name', type: 'text', width: '150px' },
      { title: 'Member Firm Code', columnName: 'name', type: 'text', width: '150px' },
      { title: 'Country Code', columnName: 'name', type: 'text', width: '150px' },
      { title: 'Country Name', columnName: 'name', type: 'text', width: '150px' },
      { title: 'Office Code', columnName: 'name', type: 'text', width: '150px' },
      { title: 'Geo Code', columnName: 'name', type: 'text', width: '150px' }
    ];
    return containermapping;
  }
  public static basemapping = function (): Array<any> {
    let basemapping = [
      { title: 'Container id', columnName: 'name', type: 'text', width: '100px' },
      { title: 'Container Name', columnName: 'name', type: 'text', width: '150px' },
      { title: 'Container Code', columnName: 'name', type: 'text', width: '150px' },
      { title: 'Member Firm Code', columnName: 'name', type: 'text', width: '150px' },
      { title: 'Country Code', columnName: 'name', type: 'text', width: '150px' },
      { title: 'Country Name', columnName: 'name', type: 'text', width: '150px' },
      { title: 'Office Code', columnName: 'name', type: 'text', width: '150px' },
      { title: 'Geo Code', columnName: 'name', type: 'text', width: '150px' }
    ];
    return basemapping;
  }
  public static onboardedapp = function (): Array<any> {
    let onboardedapp = [
      { title: '#', columnName: 'name', type: 'text', width: '100px' },
      { title: 'Code', columnName: 'name', type: 'text', width: '150px' },
      { title: 'Description', columnName: 'name', type: 'text', width: '150px' }
    ];
    return onboardedapp;
  }
  public static audit = function (): Array<any> {
    let audit = this._main.slice();
    audit.splice(4, 0,
      { title: 'Outlook Display Name', columnName: 'name', type: 'text', width: '90px' }
    );

    audit.push(
      { title: 'Modified By', columnName: 'name', type: 'text', width: '70px' },
      { title: 'Reverted By', columnName: 'name', type: 'text', width: '70px' },
      { title: 'Comments ', columnName: 'name', type: 'text', width: '55px' },
      { title: 'SN Ticket Number', columnName: 'name', type: 'text', width: '55px' },
    );
    return audit;
  };
  public static sync = function (): Array<any> {
    let main = this._main.slice();
    main.unshift(
      { title: 'GUID From PDI (EMPGUID)', columnName: 'name', type: 'text', width: '65px' },
      { title: 'Global Person ID (DC2GUID)', columnName: 'name', type: 'text', width: '65px' },
      { title: 'Person Id (EmpCode)', columnName: 'name', type: 'text', width: '65px' },
      { title: 'Previous Person Id', columnName: 'name', type: 'text', width: '65px' });
    main.push({ title: '', columnName: 'name', type: 'actions', width: '20px' });

    return main;
  };

}
